import { isAfter, isBefore, parseISO } from 'date-fns';
import { isEmpty, isNull } from 'lodash';
import { node } from 'prop-types';
import { createContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useFetch, useUser } from 'hooks';
import { appService } from 'services';
import { setFooterBanner } from 'store';

export const DealsContext = createContext();

const DealsContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { call: dealsCall, loading, data, setData } = useFetch({ filterUserCompany: true, withSetState: false });
  const { currentUser } = useUser();

  useEffect(() => {
    getDeals();
  }, []);

  const today = new Date();

  const getDeals = async () => {
    const { data } =
      (await dealsCall({
        service: appService.getStrapiServiceName(),
        method: 'get',
        path: 'api/deals-pages',
        query: {
          populate: 'deep,4'
        }
      })) || {};

    const dealsData = data?.body?.data?.[0];

    if (!isEmpty(dealsData)) {
      const filteredDeals = dealsData?.deals?.filter((deal) => {
        return (
          !isEmpty(deal?.companies?.find((c) => parseInt(c.castelisId) === parseInt(currentUser?.businessId))) &&
          !isEmpty(deal?.statuses?.find((s) => parseInt(s.castelisId) === parseInt(currentUser?.businessRoleId))) &&
          !isNull(deal?.startDate) &&
          isAfter(today, parseISO(deal?.startDate)) &&
          !isNull(deal?.endDate) &&
          isBefore(today, parseISO(deal?.endDate))
        );
      });

      if (!isEmpty(dealsData?.helpBanner)) dispatch(setFooterBanner(dealsData?.helpBanner));

      setData({
        ...data,
        data: [
          {
            ...dealsData,
            deals: filteredDeals
          }
        ]
      });
    }
  };

  const providerValues = {
    // Deals
    getDeals,
    loading,
    data
  };

  return <DealsContext.Provider value={providerValues}>{children}</DealsContext.Provider>;
};

DealsContextProvider.propTypes = {
  children: node.isRequired
};

export default DealsContextProvider;
